export const TitleWeight = {
  Light: 'normal',
  SemiLight: 'normal',
  Regular: 'normal',
  SemiBold: 'semibold',
  Bold: 'bold',
} as const;

export type TitleWeight = (typeof TitleWeight)[keyof typeof TitleWeight];
